import { FC } from 'react';

import { LocationInput, TextInput, PhoneInput } from '@carcareers/components';

export interface RooftopInputProps {
  name?: string;
  type?: 'authorizedRooftops' | 'ownedRooftops' | 'rooftops' | 'rooftop';
  index?: number;
}

export const RooftopInput: FC<RooftopInputProps> = ({ index, name, type = 'authorizedRooftops' }) => {
  const indexString = index !== undefined ? `.${index}` : '';
  const prefixString = `${type}${indexString}`;
  const prefix = type === 'rooftop' ? '' : prefixString.length > 0 ? `${prefixString}.` : '';

  return (
    <>
      <TextInput required fullWidth label="Rooftop Name" name={`${name ?? prefix}name`} />
      <LocationInput required fullWidth label="Location" name={`${name ?? prefix}location`} />
      <PhoneInput required fullWidth label="Phone Number" name={`${name ?? prefix}phone`} />
      <TextInput required fullWidth label="Email" name={`${name ?? prefix}email`} />
      <TextInput fullWidth label="Website" name={`${name ?? prefix}website`} />
      <TextInput fullWidth multiline rows={6} label="Business Description" name={`${name ?? prefix}description`} />
    </>
  );
};
